import { Condition } from '../Questionnaires/QuestionnairesList/components/types';
import { ConditionSelectorOption } from './interface';
import { useCondition } from './useCondition';
import { createOptions, getSelectedOption } from './utils';

interface UseConditionOptionsProps {
  conditions: Condition[];
  selectedConditionId: string;
}

interface UseConditionOptionsReturn {
  options: ConditionSelectorOption[];
  selectedOption?: ConditionSelectorOption | null;
}

function useConditionOptions({
  conditions,
  selectedConditionId
}: UseConditionOptionsProps): UseConditionOptionsReturn {
  const { condition } = useCondition(selectedConditionId);
  const selectedOption = getSelectedOption(selectedConditionId, conditions, condition);

  return {
    options: createOptions(conditions),
    selectedOption
  };
}

export default useConditionOptions;
